<template>
  <el-row class="xh-esg-list">
    <el-col :span="24">
      <div class="xh-esg-right-content">
        <el-row v-if="tableData.length">
          <el-col
            :span="24"
            v-for="(item, index) in tableData"
            :key="index"
            @click.native="showRowData(item)"
          >
            <el-card :body-style="{ padding: '0px' }" shadow="never">
              <el-row class="content-item">
                <el-col :span="19">
                  <div class="content-item-title">
                    {{ item.title }}
                  </div>
                  <div class="content-item-title-sub">
                    {{ item.Summary | empty }}
                  </div>
                  <div class="content-item-tips">
                    <span class="content-item-tips-text">
                      来源：{{ item.ExternalSource }}
                    </span>
                    <span class="content-item-tips-text">
                      {{ item.publishTime | dayFormat }}
                    </span>
                  </div>
                </el-col>
                <el-col :span="4" :offset="1">
                  <!-- <img
                    src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
                    class="content-item-image"
                  /> -->
                  <img
                    v-if="$filters.empty(item.logoFile)"
                    :src="item.logoFile | empty"
                    class="content-item-image"
                  />
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row v-else class="xh-esg-right-content-empty">
          <el-col :span="24"> 暂无数据 </el-col>
        </el-row>
      </div>
      <div class="xh-esg-right-pagination pageArea" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="searchData.pageSize"
          layout="total, sizes, prev, slot, next"
          :total="searchData.pageCount"
        >
          <el-button class="page-area-number">{{
            searchData.pageNo + " / " + searchData.pageTotal
          }}</el-button>
        </el-pagination>
        <el-input-number
          v-model="searchData.pageNo"
          :max="searchData.pageTotal || 1"
          :step="1"
          :step-strictly="true"
          :controls="false"
          class="page-area-input"
          @keyup.native="checknumber($event)"
          :min="1"
        ></el-input-number>
        <el-button
          @click="handleClickEnter()"
          size="mini"
          type="primary"
          class="page-area-go"
          >GO</el-button
        >
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      searchData: {
        pageNo: 1,
        pageSize: 10,
        pageTotal: 0,
        pageCount: 0,
        limitTime: null,
      },
      tableData: [],
    };
  },
  props: {
    classifyCode: String,
  },
  mounted() {
    this.searchTableData();
  },
  methods: {
    ...mapActions("dynamicInfo/index", {
      getPageList: "GET_PAGE_LIST",
    }),
    checknumber(e) {
      var keynum = window.event ? e.keyCode : e.which; //获取键盘码
      if (keynum == 189 || keynum == 190 || keynum == 109) {
        e.target.value = "";
      }
    },
    handleSizeChange(size) {
      this.searchData.pageSize = size;
      this.searchTableData();
    },
    handleCurrentChange(index) {
      this.searchData.pageNo = index;
      this.searchTableData();
    },
    handleClickEnter() {
      this.searchTableData();
    },
    showRowData({ newsId }) {
      let params = {
        path: "/dynamicInfo/detail",
        query: {
          newsId,
        },
      };
      this.$router.push(params);
    },
    resetSearchData() {
      this.searchData = {
        pageNo: 1,
        pageSize: 10,
        pageTotal: 0,
        pageCount: 0,
        limitTime: null,
      };
      this.tableData = [];
    },
    searchTableData() {
      this.loading = true;
      let tableData = this.tableData;
      let item = tableData[0];
      this.searchData.limitTime = item?.publishTime;
      this.searchData.classifyCode = this.classifyCode;
      this.getPageList(this.searchData).then((res) => {
        let { data, page } = res;
        let searchData = this.searchData;
        if (page) {
          searchData.pageNo = page.currentPage;
          searchData.pageSize = page.pageSize;
          searchData.pageTotal = page.totalPage;
          searchData.pageCount = page.totalCount;
        }
        this.tableData = data;
        this.loading = false;
      });
    },
  },
  watch: {
    classifyCode(code) {
      this.resetSearchData();
      this.searchTableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-list {
  .xh-esg-right-content {
    background-color: var(--comp_06);
    padding: 0 20px;
    min-height: 520px;
    display: flex;
    .xh-esg-right-content-empty {
      color: var(--font_01);
      margin: auto;
    }
    /deep/ .el-card {
      border-radius: 0;
      background-color: var(--comp_06);
      border: 1px solid var(--comp_06);
      border-bottom: 1px solid var(--comp_02);
    }
    .content-item {
      padding: 20px 0;
      .content-item-title {
        font-size: 14px;
        font-weight: 500;
        color: var(--font_01);
        line-height: 20px;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .content-item-title-sub {
        font-size: 12px;
        font-weight: 400;
        color: var(--font_01);
        line-height: 17px;
      }
      .content-item-tips {
        .content-item-tips-text {
          font-size: 10px;
          font-weight: 400;
          color: #a1a7af;
          line-height: 14px;
          margin-right: 20px;
        }
      }
      .content-item-image {
        width: 160px;
        height: 90px;
        display: block;
      }
    }
  }
  .xh-esg-right-pagination {
    padding: 5px 0 0 0;
    text-align: right;

    .page-area-number {
      cursor: not-allowed;
      margin-left: 5px;
      margin-right: 5px;
    }
    .page-area-input {
      width: 50px;
      margin-left: 10px;
    }
    .page-area-go {
      width: 50px;
      padding: 6px 15px;
    }
  }
}
</style>